/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 26/04/2022
 */

import * as React from 'react';
import { View, Image, StyleSheet } from '@react-pdf/renderer';

import logo from '@/wpt-lib/assets/pdf/uts';

const Header = () => {
    return (
        <View style={styles.header} fixed>
            <View style={styles.row}>
                <Image source={logo} style={styles.logo} />
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    header: {
        paddingHorizontal: 10,
        marginTop: 10,
        marginBottom: 20,
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    logo: {
        height: 40,
        width: 40,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#e0e0e0',
    },
});

export default Header;
